import axios, { AxiosResponse, AxiosError, InternalAxiosRequestConfig } from 'axios';
import { navigate } from '../utils/navigation';

const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (typeof window !== 'undefined' && window.location.port === '3000' ? `http://${window.location.hostname}:8000` : (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:8000'));

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// ✅ Request interceptor
axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('fraudguard_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// ✅ Response interceptor
axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      console.warn('[Axios] Unauthorized access detected, clearing session.');
      localStorage.removeItem('fraudguard_token');
      localStorage.removeItem('fraudguard_user');
      if (window.location.pathname !== '/login') {
        navigate('/login');
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;